import { useParams } from 'react-router-dom';
import { EditOrderPathParams, ArrowType, OrderType } from '@app/react/const/type';

type T = { cartId: string; arrowType: ArrowType; orderType: OrderType };

export const useEditOrderPathParams = (): EditOrderPathParams => {
    const { cartId, arrowType, orderType } = useParams<T>();

    return {
        cartId: parseInt(cartId, 10),
        arrowType,
        orderType,
    };
};
